import React from 'react';
import { Link } from 'react-router-dom';
import UserManagement from '../components/admin/UserManagement';
import { useAuth } from '../hooks/useAuth';
import { isAdminUser } from '../utils/adminPermissions';

const AdminUserManagementPage: React.FC = () => {
  const { user } = useAuth();
  const canManageUsers = isAdminUser(user);

  if (!canManageUsers) {
    return (
      <main className="mx-auto max-w-2xl px-4 py-10">
        <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 px-4 py-5 text-sm text-slate-900 dark:text-slate-100 shadow-sm">
          <h1 className="text-base font-semibold text-slate-900 dark:text-slate-100">Admin access required</h1>
          <p className="mt-2 text-xs text-slate-700 dark:text-slate-300">
            User management is only available to TELLURVISION administrators.
          </p>
          <div className="mt-4 flex gap-2 text-xs">
            <Link
              to="/admin"
              className="inline-flex items-center rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-1.5 font-medium text-slate-700 dark:text-slate-300 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Back to admin overview
            </Link>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="mx-auto max-w-6xl px-4 py-8 space-y-6">
      <header className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold text-slate-900 dark:text-slate-100">User management</h1>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
            View registered users and revoke access when needed.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Link
            to="/admin"
            className="inline-flex items-center rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-1.5 text-xs font-medium text-slate-700 dark:text-slate-300 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Admin overview
          </Link>
          <Link
            to="/"
            className="inline-flex items-center rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-1.5 text-xs font-medium text-slate-700 dark:text-slate-300 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Go home
          </Link>
        </div>
      </header>

      <section className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4 shadow-sm">
        <UserManagement />
      </section>
    </main>
  );
};

export default AdminUserManagementPage;
